import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-ntb-term-loan-v2.component.scss';
var FormItemBusinessNtbTermLoanV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessNtbTermLoanV2, _super);
    function FormItemBusinessNtbTermLoanV2(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessNtbTermLoanV2.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.wizard = this.element.querySelector(".form-container-wizard__wizard");
        this.buttonNextStep1 = this.element.querySelector(".js_next-step-button-1");
        this.buttonNextStep2 = this.element.querySelector(".js_next-step-button-2");
        this.buttonSubmit = this.element.querySelector(".js-businessNtbTermLoan__submit");
        this.buttonRelatedParties = this.element.querySelector('.permission-to-apply-tooltip-related-parties');
        this.paragraphRelatedParties = this.element.querySelector('.permission-to-apply-tooltip-related-parties-text');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayDeclined = this.form.querySelector(".form-container__declined");
            this.displayMessage = this.form.querySelector(".form-container__message");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        // redirected customer
        this.parameterArray = [];
        this.cusIsRedirected = 'NO';
        this.productRedirectedFrom = '';
        this.cusBank = '';
        // inputs
        this.entityType = this.element.querySelector(".js-apply-now-entity-type");
        this.entityIdNumGroup = this.element.querySelector(".js-business-ntb-term-loan-ein-group");
        this.businessRegNumGroup = this.element.querySelector(".js-business-ntb-term-loan-brn-group");
        this.businessTradeYears = this.element.querySelector("input[name='business-trade-years']");
        this.bttDate = this.element.querySelector("input[name=date]");
        this.bttTime = this.element.querySelector("input[name=time]");
        this.upSell = "";
        this.channel = "";
        // radio
        this.permissionToApplySelection = Array.from(this.element.querySelectorAll("input[name='permission-to-apply']"));
        this.consentPersonalSelection = Array.from(this.element.querySelectorAll("input[name='consent-personal']"));
        this.consentFraudCheckSelection = Array.from(this.element.querySelectorAll("input[name='consent-fraud-check']"));
        this.businessRescueDissolvedLiquidationSequesDebtReviewSelection = Array.from(this.element.querySelectorAll("input[name='business-administration-items']"));
        this.legalDisabilitySelection = Array.from(this.element.querySelectorAll("input[name='legal-disability']"));
        this.covid19GovernmentLoanSelection = Array.from(this.element.querySelectorAll("input[name='covid-19-government-loan']"));
        this.businessIncomeSelection = Array.from(this.element.querySelectorAll("input[name='business-income']"));
        this.businessExpensesSelection = Array.from(this.element.querySelectorAll("input[name='business-expenses']"));
        // values
        this.permissionToApply = "";
        this.consentPersonal = "";
        this.consentProcessInformation = "";
        this.consentFraudCheck = "";
        this.businessRescueDissolvedLiquidationSequesDebtReview = "";
        this.legalDisability = "";
        this.covid19GovernmentLoan = "";
        this.businessIncome = "";
        this.businessExpenses = "";
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector('.data-sharing-telesale-hide-btn');
        this.dataSharingTeleSaleShowBtn = this.element.querySelector('.data-sharing-telesale-show-btn');
        this.dataSharingTeleSaleTextArea = this.element.querySelector('.data-sharing-telesale');
        this.dataSharingSmsShowBtn = this.element.querySelector('.data-sharing-email-show-btn');
        this.dataSharingSmsHideBtn = this.element.querySelector('.data-sharing-email-hide-btn');
        this.dataSharingSmsTextArea = this.element.querySelector('.data-sharing-email');
        this.dataSharingEmailHideBtn = this.element.querySelector('.data-sharing-sms-hide-btn');
        this.dataSharingEmailShowBtn = this.element.querySelector('.data-sharing-sms-show-btn');
        this.dataSharingEmailTextArea = this.element.querySelector('.data-sharing-sms');
        if (this.entityType) {
            this.updateForm('');
        }
        if (this.businessTradeYears) {
            this.businessTradeYears.setAttribute('maxlength', '3');
        }
    };
    FormItemBusinessNtbTermLoanV2.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _button = pEvent.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                _this.businessNtbTermLoanValidations_Step3();
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                }
            });
        }
        this.buttonRelatedParties.addEventListener('click', function (e) {
            e.preventDefault();
            if (_this.paragraphRelatedParties.hasAttribute('hidden')) {
                _this.paragraphRelatedParties.removeAttribute('hidden');
            }
            else {
                _this.paragraphRelatedParties.setAttribute('hidden', 'true');
            }
        });
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute('hidden');
            _this.dataSharingTeleSaleShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleShowBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute('hidden');
            _this.dataSharingSmsShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsShowBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute('hidden');
            _this.dataSharingEmailShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailShowBtn.removeAttribute('hidden');
        });
        if (this.buttonNextStep2) {
            this.buttonNextStep2.addEventListener("click", function (event) {
                if (!_this.businessNtbTermLoanValidations_Step2()) {
                    event.stopImmediatePropagation(); // Stop from going to next step
                }
            });
        }
        if (this.entityType) {
            this.entityType.addEventListener("change", function (pEvent) {
                _this.updateForm(_this.entityType.value);
            });
        }
        if (this.permissionToApplySelection) {
            this.permissionToApplySelection.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.permissionToApply = evt.value;
                if (_this.permissionToApply.toUpperCase() === "NO") {
                    _this.showDisplayView("declined");
                }
            }); });
        }
        if (this.consentPersonalSelection) {
            this.consentPersonalSelection.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.consentPersonal = evt.value;
                if (_this.consentPersonal.toUpperCase() === "YES") {
                    _this.showDisplayView("message");
                }
            }); });
        }
        if (this.consentFraudCheckSelection) {
            this.consentFraudCheckSelection.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.consentFraudCheck = evt.value;
                if (_this.consentFraudCheck.toUpperCase() === "NO") {
                    _this.showDisplayView("message");
                }
            }); });
        }
        if (this.businessRescueDissolvedLiquidationSequesDebtReviewSelection) {
            this.businessRescueDissolvedLiquidationSequesDebtReviewSelection.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.businessRescueDissolvedLiquidationSequesDebtReview = evt.value;
                if (_this.businessRescueDissolvedLiquidationSequesDebtReview.toUpperCase() === "YES") {
                    _this.showDisplayView("message");
                }
            }); });
        }
        if (this.legalDisabilitySelection) {
            this.legalDisabilitySelection.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.legalDisability = evt.value;
                if (_this.legalDisability.toUpperCase() === "YES") {
                    _this.showDisplayView("message");
                }
            }); });
        }
        if (this.covid19GovernmentLoanSelection) {
            this.covid19GovernmentLoanSelection.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.covid19GovernmentLoan = evt.value;
                if (_this.covid19GovernmentLoan.toUpperCase() === "YES") {
                    _this.showDisplayView("message");
                }
            }); });
        }
        if (this.businessIncomeSelection) {
            this.businessIncomeSelection.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.businessIncome = evt.value;
            }); });
        }
        if (this.businessExpensesSelection) {
            this.businessExpensesSelection.map(function (item) { return item.addEventListener("click", function (event) {
                var evt = event.target;
                _this.businessExpenses = evt.value;
            }); });
        }
        // This adds slashes to the business registration number
        var businessReg = this.element.querySelector(".js-business-ntb-term-loan-brn");
        if (businessReg) {
            businessReg.addEventListener("input", function (pEvent) {
                if ((pEvent.inputType !== "deleteContentBackward") && (pEvent.inputType !== "deleteContentForward")) {
                    var reg = pEvent.target.value;
                    pEvent.target.value = _this.validationService.formatBusinessReg(reg);
                }
            });
            businessReg.addEventListener("blur", function (pEvent) {
                var reg = pEvent.target.value;
                pEvent.target.value = _this.validationService.formatExpression(reg);
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            // This will reset step 2
            if (_this.entityType) {
                _this.updateForm(_this.entityType.value);
            }
            if (_this.wizard) {
                var event_1 = new CustomEvent("custom_wizard_reset_event");
                _this.wizard.dispatchEvent(event_1);
            }
            _this.resetForm();
            _this.showDisplayView("");
        }, false);
    };
    FormItemBusinessNtbTermLoanV2.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemBusinessNtbTermLoanV2.prototype.getURLParameters = function (url) {
        if (this.parameterArray.length === 0) {
            var _urlSplit = url.split('?');
            if (_urlSplit[1]) {
                var _paramters = _urlSplit[1].split('&');
                if (_paramters.length > 0) {
                    for (var i = 0; i < _paramters.length; i++) {
                        var _parameterSplit = _paramters[i].split('=');
                        if (_parameterSplit.length > 1) {
                            if (_parameterSplit[0] === "cusIsRedirected") {
                                this.parameterArray.push({ paramName: _parameterSplit[0], value: _parameterSplit[1] });
                            }
                            else if (_parameterSplit[0] === "productRedirectedFrom") {
                                this.parameterArray.push({ paramName: _parameterSplit[0], value: _parameterSplit[1] });
                            }
                            else if (_parameterSplit[0] === "cusBank") {
                                this.parameterArray.push({ paramName: _parameterSplit[0], value: _parameterSplit[1] });
                            }
                        }
                    }
                }
            }
        }
        if (this.parameterArray.length > 0) {
            for (var k = 0; k < this.parameterArray.length; k++) {
                if (this.parameterArray[k]['paramName'] === "cusIsRedirected") {
                    this.cusIsRedirected = this.parameterArray[k]['value'];
                }
                else if (this.parameterArray[k]['paramName'] === "productRedirectedFrom") {
                    this.productRedirectedFrom = this.parameterArray[k]['value'];
                }
                else if (this.parameterArray[k]['paramName'] === "cusBank") {
                    this.cusBank = this.parameterArray[k]['value'];
                    this.cusBank = this.cusBank.replace('#', '');
                }
            }
        }
    };
    FormItemBusinessNtbTermLoanV2.prototype.updateForm = function (pType) {
        if (this.entityIdNumGroup && this.businessRegNumGroup) {
            var _entityIdNumberField = this.element.querySelector("input[name=entity-identity-number]");
            var _businessRegNumberField = this.element.querySelector("input[name=business-reg-number]");
            if (pType === "SOLE") {
                this.entityIdNumGroup.classList.remove("form__group--hidden");
                this.businessRegNumGroup.classList.add("form__group--hidden");
                if (_businessRegNumberField) {
                    _businessRegNumberField.value = '';
                }
            }
            else if (pType !== "") {
                this.entityIdNumGroup.classList.add("form__group--hidden");
                this.businessRegNumGroup.classList.remove("form__group--hidden");
                if (_entityIdNumberField) {
                    _entityIdNumberField.value = '';
                }
            }
            else {
                this.entityIdNumGroup.classList.add("form__group--hidden");
                this.businessRegNumGroup.classList.add("form__group--hidden");
                if (_entityIdNumberField && _businessRegNumberField) {
                    _entityIdNumberField.value = '';
                    _businessRegNumberField.value = '';
                }
            }
        }
    };
    FormItemBusinessNtbTermLoanV2.prototype.businessNtbTermLoanValidations_Step2 = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var businessTradeYearsGroup = this.businessTradeYears.closest(".form__group");
        selectionArray.push(businessTradeYearsGroup);
        var permissionToApplySelectionGroup = this.permissionToApplySelection[0].closest(".form__group");
        selectionArray.push(permissionToApplySelectionGroup);
        var consentPersonalSelectionGroup = this.consentPersonalSelection[0].closest(".form__group");
        selectionArray.push(consentPersonalSelectionGroup);
        var consentFraudCheckSelectionGroup = this.consentFraudCheckSelection[0].closest(".form__group");
        selectionArray.push(consentFraudCheckSelectionGroup);
        var businessRescueDissolvedLiquidationSequesDebtReviewSelectionGroup = this.businessRescueDissolvedLiquidationSequesDebtReviewSelection[0].closest(".form__group");
        selectionArray.push(businessRescueDissolvedLiquidationSequesDebtReviewSelectionGroup);
        var legalDisabilitySelectionGroup = this.legalDisabilitySelection[0].closest(".form__group");
        selectionArray.push(legalDisabilitySelectionGroup);
        var covid19GovernmentLoanSelectionGroup = this.covid19GovernmentLoanSelection[0].closest(".form__group");
        selectionArray.push(covid19GovernmentLoanSelectionGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove('form__group--error');
            var errorMessage = groupItem.querySelector('.form__group--error_message');
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        // Radio Details Selection Error
        if (!businessTradeYearsGroup.classList.contains("form__group--hidden")) {
            if (this.businessTradeYears.value.length === 0) {
                isValid = false;
                businessTradeYearsGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = 'This field is required';
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                businessTradeYearsGroup.appendChild(_errorDiv);
            }
            else if (isNaN(this.businessTradeYears.value)) {
                isValid = false;
                businessTradeYearsGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = 'Please insert only numbers into this field';
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                businessTradeYearsGroup.appendChild(_errorDiv);
            }
        }
        if (!permissionToApplySelectionGroup.classList.contains("form__group--hidden")) {
            if (this.permissionToApply === "") {
                isValid = false;
                permissionToApplySelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                permissionToApplySelectionGroup.appendChild(_errorDiv);
            }
        }
        if (!consentPersonalSelectionGroup.classList.contains("form__group--hidden")) {
            if (this.consentPersonal === "") {
                isValid = false;
                consentPersonalSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                consentPersonalSelectionGroup.appendChild(_errorDiv);
            }
        }
        if (!consentFraudCheckSelectionGroup.classList.contains("form__group--hidden")) {
            if (this.consentFraudCheck === "") {
                isValid = false;
                consentFraudCheckSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                consentFraudCheckSelectionGroup.appendChild(_errorDiv);
            }
        }
        if (!businessRescueDissolvedLiquidationSequesDebtReviewSelectionGroup.classList.contains("form__group--hidden")) {
            if (this.businessRescueDissolvedLiquidationSequesDebtReview === "") {
                isValid = false;
                businessRescueDissolvedLiquidationSequesDebtReviewSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                businessRescueDissolvedLiquidationSequesDebtReviewSelectionGroup.appendChild(_errorDiv);
            }
        }
        if (!legalDisabilitySelectionGroup.classList.contains("form__group--hidden")) {
            if (this.legalDisability === "") {
                isValid = false;
                legalDisabilitySelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                legalDisabilitySelectionGroup.appendChild(_errorDiv);
            }
        }
        if (!covid19GovernmentLoanSelectionGroup.classList.contains("form__group--hidden")) {
            if (this.covid19GovernmentLoan === "") {
                isValid = false;
                covid19GovernmentLoanSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                covid19GovernmentLoanSelectionGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemBusinessNtbTermLoanV2.prototype.businessNtbTermLoanValidations_Step3 = function () {
        var selectionArray = [];
        var radioErrorDetails = "This field is required";
        var isValid = true;
        // Radio Details Selection Error
        var businessIncomeSelectionGroup = this.businessIncomeSelection[0].closest(".form__group");
        selectionArray.push(businessIncomeSelectionGroup);
        var businessExpensesSelectionGroup = this.businessExpensesSelection[0].closest(".form__group");
        selectionArray.push(businessExpensesSelectionGroup);
        // Clear errors
        selectionArray.forEach(function (groupItem) {
            groupItem.classList.remove('form__group--error');
            var errorMessage = groupItem.querySelector('.form__group--error_message');
            if (errorMessage) {
                errorMessage.remove();
            }
        });
        if (!businessIncomeSelectionGroup.classList.contains("form__group--hidden")) {
            if (this.businessIncome === "") {
                isValid = false;
                businessIncomeSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                businessIncomeSelectionGroup.appendChild(_errorDiv);
            }
        }
        if (!businessExpensesSelectionGroup.classList.contains("form__group--hidden")) {
            if (this.businessExpenses === "") {
                isValid = false;
                businessExpensesSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                businessExpensesSelectionGroup.appendChild(_errorDiv);
            }
        }
        return isValid;
    };
    FormItemBusinessNtbTermLoanV2.prototype.submitForm = function (pForm) {
        var _this = this;
        var _applicantName = pForm.querySelector(".form-container__success__applicantName");
        _applicantName.innerHTML = '';
        // Check if customer has been redirected
        this.getURLParameters(window.location.href);
        // Personal Details
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _surname = this.form.querySelector("input[name=last-name]");
        var _idNumber = this.form.querySelector("input[name=identity-number]");
        var _contactNumber = this.form.querySelector("input[name=contact-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        // Personal Details - Consents
        var _permissionToApply = this.permissionToApply;
        var _consentPersonal = this.consentPersonal;
        var _consentProcessInformation = this.consentProcessInformation;
        var _consentFraudCheck = this.consentFraudCheck;
        var _businessAdministrationItems = this.businessRescueDissolvedLiquidationSequesDebtReview;
        var _legalDisability = this.legalDisability;
        var _covid19GovernmentLoan = this.covid19GovernmentLoan;
        // Business Details
        var _entityType = this.form.querySelector("select[name=entity-type]");
        var _businessName = this.form.querySelector("input[name=business-name]");
        var _entityIdNumber = this.form.querySelector("input[name=entity-identity-number]");
        var _businessRegNumber = this.form.querySelector("input[name=business-reg-number]");
        var _businessEmailAdress = this.form.querySelector("input[name=business-email-address]");
        var _businessIndustry = this.form.querySelector("select[name=business-industry]");
        var _businessDescription = this.form.querySelector("input[name=business-descrpition]");
        var _businessRegion = this.form.querySelector("select[name=business-region]");
        var _businessNature = this.form.querySelector("select[name=business-nature]");
        var _businessTradeYears = this.form.querySelector("input[name=business-trade-years]");
        var _businessDirectors = this.form.querySelector("select[name=business-directors]");
        // Loan Details
        var _loanAmount = this.form.querySelector("input[name=loan-amount]");
        var _loanPurpose = this.form.querySelector("input[name=loan-purpose]");
        var _businessIncome = this.businessIncome;
        var _businessIncomeAmount = this.form.querySelector("input[name=business-income-amount]");
        var _businessExpenses = this.businessExpenses;
        var _businessExpensesAmount = this.form.querySelector("input[name=business-expenses-amount]");
        var popiaConsent = this.form.querySelector("input[name=popia-consent]");
        var date = this.form.querySelector("input[name=date]");
        var time = this.form.querySelector("select[name=time]");
        var _upSell = this.upSell;
        var _channel = 'COZA';
        // Format Datetime
        var _dateTime = "anytime";
        if (date && time) {
            if (time.value !== "Anytime") {
                _dateTime = date.value + " " + time.value;
            }
        }
        // Format Business Registration Number to have no slashes (/)
        var _formatedBusRegNumber = '';
        if (_entityType.value === "SOLE") {
            if (_entityIdNumber) {
                _formatedBusRegNumber = _entityIdNumber.value;
            }
        }
        else {
            if (_businessRegNumber) {
                _formatedBusRegNumber = _businessRegNumber.value.replace(/\//g, '');
            }
        }
        var _postData = {
            // Redirect Details
            'cusIsRedirected': (this.cusIsRedirected ? this.cusIsRedirected : ""),
            'productRedirectedFrom': (this.productRedirectedFrom ? this.productRedirectedFrom : ""),
            'cusBank': (this.cusBank ? this.cusBank : ""),
            // Personal Details
            'Applicant_Firstname': (_firstname ? _firstname.value : ""),
            'Applicant_Surname': (_surname ? _surname.value : ""),
            'Applicant_IDNumber': (_idNumber ? _idNumber.value : ""),
            'ContactNumber': (_contactNumber ? _contactNumber.value : ""),
            'Applicant_Email': (_emailAddress ? _emailAddress.value : ""),
            // Personal Details - Consents
            'Authority_ToApply': _permissionToApply,
            'PersonalInfo_UsageConsent': ((_consentProcessInformation === 'YES' && _consentPersonal === 'YES') ? 'YES' : 'NO'),
            'Identity_FraudCheck_BusinessConsent': _consentFraudCheck,
            'CreditBureau_Check_BusinessConsent': _consentFraudCheck,
            'Identity_FraudCheck_CustomerConsent': _consentFraudCheck,
            'CreditBureau_Check_CustomerConsent': _consentFraudCheck,
            'IsBusiness_UnderRescue': _businessAdministrationItems,
            'IsBusiness_Wound_Dissovled_liquid': _businessAdministrationItems,
            'IsBusiness_Unable_toPay': _businessAdministrationItems,
            'IsBusiness_UnderDebtReview': _businessAdministrationItems,
            'Customer_HasLegalDisability': _legalDisability,
            'C19_Loan': _covid19GovernmentLoan,
            // Business Details
            'Business_EntityType': (_entityType ? _entityType.value : ""),
            'Business_Name': (_businessName ? _businessName.value : ""),
            // 'entityIdNumber': (_entityIdNumber ? _entityIdNumber.value : ``),
            'Business_RegNumber': _formatedBusRegNumber,
            'Business_Email': (_businessEmailAdress ? _businessEmailAdress.value : ""),
            'INDUSTRY': (_businessIndustry ? _businessIndustry.value : ""),
            'Business_Description': (_businessDescription ? _businessDescription.value : ""),
            'Business_region': (_businessRegion ? _businessRegion.value : ""),
            'Business_NatureOf': (_businessNature ? _businessNature.value : ""),
            'Business_Trading_Years': (_businessTradeYears ? _businessTradeYears.value : ""),
            'Total_Directors': (_businessDirectors ? _businessDirectors.value : ""),
            // Loan Details
            'Loan_Amount': (_loanAmount ? Number(_loanAmount.value) : ""),
            'Purpose_Of_Loan': (_loanPurpose ? _loanPurpose.value : ""),
            'Income_Freq': _businessIncome,
            'Business_Income': (_businessIncomeAmount ? Number(_businessIncomeAmount.value) : ""),
            'Expenses_Freq': _businessExpenses,
            'Business_Expenses': (_businessExpensesAmount ? Number(_businessExpensesAmount.value) : ""),
            'Best_Call_Time': _dateTime,
            'Up_Sell': _upSell,
            'Channel': _channel,
            'dataPrivacyConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingGroup': this.getDataConsentValue(pForm, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(pForm, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(pForm, 'data-sharing-boarders'),
            'dataSharingTelesale': this.getDataConsentValue(pForm, 'data-sharing-telesale'),
            'dataSharingEmail': this.getDataConsentValue(pForm, 'data-sharing-email'),
            'dataSharingSms': this.getDataConsentValue(pForm, 'data-sharing-sms'),
        };
        this.showDisplayView("loader");
        // variables
        var url = this.baseUrl + "/sites/services/NTBBTLForm.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var ntbBTLPayloadJson = 'ntbbtlPayload=' + JSON.stringify(_postData);
        // service
        this.formsService.postForm(url, ntbBTLPayloadJson, config).then(function (pResponse) {
            if (pResponse) {
                if (pResponse.data) {
                    if (pResponse.data.covidTPInfoResponse) {
                        if (pResponse.data.covidTPInfoResponse.statusDescription) {
                            if (pResponse.data.covidTPInfoResponse.statusDescription === 'success') {
                                _applicantName.innerHTML = _firstname.value;
                                _this.analyticsService.dtmFormComplete("complete", pResponse.code);
                                _this.showDisplayView("success");
                            }
                            else {
                                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                                _this.showDisplayView("error");
                            }
                        }
                        else {
                            _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                            _this.showDisplayView("error");
                        }
                    }
                    else {
                        _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                        _this.showDisplayView("error");
                    }
                }
                else {
                    _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                    _this.showDisplayView("error");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessNtbTermLoanV2.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayDeclined.classList.add("hidden");
        this.displayMessage.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "declined":
                this.displayDeclined.classList.remove("hidden");
                break;
            case "message":
                this.displayMessage.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    FormItemBusinessNtbTermLoanV2.prototype.resetForm = function () {
        // redirect customer
        this.cusIsRedirected = "NO";
        this.productRedirectedFrom = "";
        this.cusBank = "";
        // values
        this.permissionToApply = "";
        this.consentProcessInformation = "";
        this.consentFraudCheck = "";
        this.businessRescueDissolvedLiquidationSequesDebtReview = "";
        this.legalDisability = "";
        this.covid19GovernmentLoan = "";
        this.businessIncome = "";
        this.businessExpenses = "";
        this.updateForm('');
    };
    return FormItemBusinessNtbTermLoanV2;
}(Base));
export { FormItemBusinessNtbTermLoanV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-ntb-term-loan-v2/form-item-business-ntb-term-loan-v2.component.ts
// module id = 877
// module chunks = 0